var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAds(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 22,
    viewBox: "0 0 27 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.875 0.5C26.4844 0.5 27 1.01562 27 1.625V2.75V19.25V20.375C27 21.0312 26.4844 21.5 25.875 21.5C25.2188 21.5 24.75 21.0312 24.75 20.375V20.1406L16.4062 17.8438C16.0312 19.9531 14.1562 21.5 12 21.5C9.51562 21.5 7.5 19.4844 7.5 17C7.5 16.4844 7.59375 15.9688 7.73438 15.5L2.25 14V14.375C2.25 15.0312 1.73438 15.5 1.125 15.5C0.46875 15.5 0 15.0312 0 14.375V13.3906V12.5V9.5V8.65625V7.625C0 7.01562 0.46875 6.5 1.125 6.5C1.73438 6.5 2.25 7.01562 2.25 7.625V8.04688L24.75 1.90625V1.625C24.75 1.01562 25.2188 0.5 25.875 0.5ZM24.75 17.7969V4.25L2.25 10.3906V11.6562L24.75 17.7969ZM9.75 17C9.75 18.2656 10.7344 19.25 12 19.25C13.125 19.25 14.1094 18.4062 14.2031 17.2812L9.9375 16.1094C9.79688 16.3906 9.75 16.6719 9.75 17Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAds);
export default __webpack_public_path__ + "static/media/_ads.7f51e29f96e1737f9ebc1726dd4e7542.svg";
export { ForwardRef as ReactComponent };